export default "__VITE_ASSET__CL2ifYV2__"